import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {Payday} from "../../Payday";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

/**
 * Created by jonas on 2022-09-02.
 */

export class FreeSpinsIntro implements SimplePresentation {

    name:string = "FreesSpinIntro";

    constructor() {

    }

    public shouldRun():boolean {
        const mode = Payday.model.data.mode;
        const nextMode = Payday.model.data.nextMode;
        return !Payday.model.isRestore &&
               !Payday.model.gameData.brokeTheBank &&
               mode == GameMode.NORMAL && nextMode == GameMode.FREESPIN;
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();
        Payday.autoPlayPlugin.turnOffAutoplayOnBonus();
        tl.add(() => {
            controller.setSkipCallback(() => {
                tl.progress(1, false)
            });
        });

        if (Payday.model.isRestore)
            tl.add(() => {}, '>0.5');

        tl.add(() => {
            Payday.soundPlayer.fadeOutMusic();
        });

        tl.add(Payday.soundPlayer.playSoundBased("fsSfsActivation"));
        tl.add(<any>Payday.keypadPlugin.hide(0.1), '<');

        const scatters = Payday.model.scatterIndices();
        const scatterCount = scatters.length * 3;
        tl.add(Payday.reelView.getSymbolsAt(scatters).map((scatter) => scatter.getWinAnimation()));
        tl.add(Payday.transitionScreen.showFreespinsIntro(scatterCount), '>0.33');
        tl.add(Payday.soundPlayer.playSoundBased("fsIntroOneShot"), '<');
        tl.add(Payday.soundPlayer.playLoopBased("fsIntroLoop"), '<');
        if (Payday.autoPlayPlugin.isAutoplayRound && Payday.model.data.wasFeatureBuy) {
            tl.add(() => {this.onButtonClick(controller)}, '>1.2');
        } else {
            tl.add(Payday.transitionScreen.enableButton(() => this.onButtonClick(controller)));
        }
        tl.add(() => {controller.setSkipCallback()});
    }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            Payday.keypadPlugin.setZeroBetSpinCounter(Payday.model.data.freespinsLeft);
            Payday.keypadPlugin.show(0.1);
            Payday.soundPlayer.switchMusic(GameMode.FREESPIN);
            Payday.soundPlayer.fadeInMusic()
            Payday.soundPlayer.stopLoopBased("fsIntroLoop")
        });

        tl.add(Payday.backgroundElements.setToFreespins());
        tl.add(() => Payday.reelView.setToFreespins());
        tl.add(Payday.transitionScreen.hideFreespinsIntro());

        tl.add(() => {
            controller.finish();
            controller.setSkipCallback();
        }, '>0.2');

    }
}

export class FreeSpinsRestoreIntro extends FreeSpinsIntro {
    name:string = "FreeSpinRestoreIntro";

    constructor() {
        super();

    }

    // this hackjob is only called in a very specific place when its suppose to run
    // so every time shouldRun is run it should run
    shouldRun(): boolean {
        return Payday.model.isRestore && Payday.model.data.mode == GameMode.NORMAL;
    }
}